import BaseGraphController from "./base_graph_controller";
export default class extends BaseGraphController {
  // Number of intervals between displayed x-axis labels (5 labels total).
  MAX_LABEL_COUNT_INDEX = 4;
  // The max number of labels we want to display on the x axis.
  MAX_TICK_COUNT = 5;

  // Chart config.
  config(labels, data) {
    const steps = this.labelSteps(labels);

    const config = {
      type: "line",
      data: {
        labels: labels,
        datasets: data,
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
              padding: 10,
              includeBounds: true,
              max: this.MAX_TICK_COUNT,
              callback: function (index) {
                // Show 5 evenly spaced labels including first and last
                return [0, 1, 2, 3, 4].map(i => Math.round(i * steps)).includes(index)
                  ? this.getLabelForValue(index)
                  : "";
              }
            },
            grid: { display: false },
            border: { color: "transparent" }
          },
          y: {
            grid: {
              drawOnChartArea: false,
              drawTicks: false
            },
            ticks: { padding: 10 },
            border: { color: "transparent" }
          },
          "y-percent": {
            position: "right",
            tickColor: "transparent",
            ticks: {
              callback: function (value) { return `${(value * 100)}%`; },
              padding: 10,
            },
            grid: { drawOnChartArea: true, drawTicks: false },
            border: { color: "transparent" }
          },
        },
      }
    };

    return config;
  }

  // Returns the index spacing between selected x-axis labels
  labelSteps(labels) {
    const totalDates = labels.length;
    const step = (totalDates - 1) / this.MAX_LABEL_COUNT_INDEX;
    return step;
  }
}
